module.exports = __webpack_public_path__ + "files/61a4b7ed4d8afd09258a4f657a4c4c5b.png";